<template>
  <div class="auditInfo">
    <div class="auditName">
      {{ contentName }}
    </div>
    <div class="auditJob">{{ name }}{{ contentId }}</div>
  </div>
</template>

<script>
import publicTool from '@/utils/public';
export default {
  name: "auditInfo",
  props: ['actionType','contentId','contentName'],
  data () {
    return {
      name: publicTool.actionTypeCheck(this.actionType) + 'ID:',
    }
  },
}
</script>

<style scoped lang="scss">
.auditInfo {
  .auditName {
    width: auto !important;
    height: auto !important;
    padding: 40px 0 30px 24px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #262626;
  }

  .auditJob {
    margin-top: 10px;
    padding: 0px 0 30px 23px;
    font-family: PingFang-SC-Regular;
    font-size: 16px;
    color: #9a9a9a;
  }
}
</style>
